export default __webpack_public_path__ + "static/media/arrow_purple_icon.4782b8ab.svg";